import { render, staticRenderFns } from "./ActiveTrips.vue?vue&type=template&id=ca62ad68&scoped=true"
import script from "./ActiveTrips.vue?vue&type=script&lang=js"
export * from "./ActiveTrips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca62ad68",
  null
  
)

export default component.exports